import AutoComplete from 'js-autocomplete';

(function(callback) {
    if(document.readyState === "interactive" || document.readyState === "complete") {
        callback();
    } else {
        document.addEventListener("DOMContentLoaded", callback);
    }
})(function(){
    var autocompleteObject;

    autocomplete();

    function autocomplete() {
        autocompleteObject = new AutoComplete({
            selector: '[data-autocomplete]',
            cache: false,
            minChars: 1,
            delay: 20,
            source: function(term, response) {
                var request = new XMLHttpRequest(),
                    params = { "query": term },
                    encodedParams = Object.keys(params).map(function(param) {
                        return encodeURIComponent(param) + '=' + encodeURIComponent(params[param]);
                    }),
                    autocompleteUrl = document.querySelector('[data-autocomplete]').getAttribute('data-autocomplete');
                autocompleteUrl = (autocompleteUrl.indexOf('?') === -1) ? autocompleteUrl + '?' : autocompleteUrl + '&';
                request.open('GET', autocompleteUrl + encodedParams.join('&'), true);
                request.onload = function() {
                    if (request.status >= 200 && request.status < 400) {
                        // Success!
                        response(JSON.parse(request.responseText));
                    } else {
                        // We reached our target server, but it returned an error
                    }
                };
                request.onerror = function() {
                    // There was a connection error of some sort
                };
                request.send();
            },
            renderItem: function (item, search){
                // escape special characters
                search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
                var re = new RegExp("(.*?\\s|^)(" + search + ")(.*)", "gi");
                return '<div class="autocomplete-suggestion" data-val="' + item + '">' + item.replace(re, "$1$2<em>$3</em>") + '</div>';
            },
            onSelect: function(e, term, item){
                document.querySelector('.searchbox').submit();
            }
        });
    }
});
